import React from 'react';
import { maskDate } from '../../../masks';

const ClientStartDateNav = props => {
  const { subject: client, className } = props;

  if (!client.service_start_date) return '';

  return <div className={className}>{maskDate(client.service_start_date)}</div>;
};

export default ClientStartDateNav;



// WEBPACK FOOTER //
// ./src/components/onboarding/client/ClientStartDateNav.js